import { createRouter, createWebHistory } from 'vue-router'


import LoginView from '@base/pages/Login'

const routes = [

  
  {
    path: '/login',
    name: 'login',
    sectionTitle:'Login',
    loggedOut: true,
    component: LoginView
  },
  
  { path: '/profile', name:'profile', title: 'Profiel', component: () => import('@base/pages/User/Profile') },
  { path: '/profile/password', name:'profile_password', title: 'Wachtwoord', component: () => import('@base/pages/User/Password') },

  // TOOLS
  { path: '/tools', icon:'fa-gear',sectionTitle:'Tools', name:'tools_database', title: 'Database', component: () => import('@base/pages/Tools/Database') },
  { path: '/tools/mails', name:'tools_mails', title: 'Mails', component: () => import('@base/pages/Tools/Mails') },
  { path: '/tools/log', name:'tools_lot', title: 'Log', component: () => import('@base/pages/Tools/Log') },
  { path: '/tools/export', name:'tools_export', title: 'Exporteren', component: () => import('@custom/pages/Tools/Export') },
  { path: '/tools/permissions',   name:'tools_permissions', title:"Permissions", component: () => import('@base/pages/Tools/Permissions') },
  { path: '/tools/migrate', name:'tools_migrate', title: 'Migrate', component: () => import('@custom/pages/Tools/Migrate') },
  { path: '/tools/cache', name:'tools_cache', title: 'Cache', component: () => import('@base/pages/Tools/Cache') },
  { path: '/tools/test', name:'tools_test', title: 'Test', component: () => import('@custom/pages/Tools/Test') },
  { path: '/tools/testform', name:'tools_testform', title: 'Testform', component: () => import('@custom/pages/Tools/TestForm') },
  
  // PRODUCTS
  { path: '/products', icon:'fa-cart-shopping',sectionTitle:'Producten', name:'products_list', title: 'Overzicht', component: () => import('@custom/pages/Product/List') },
  { path: '/products/properties', name:'products_properties', title: 'Eigenschappen', component: () => import('@custom/pages/Product/Properties') },
  { path: '/products/updates', name:'products_updates', title: 'Updates', component: () => import('@custom/pages/Product/Updates') },
  { path: '/products/imageerrors', name:'products_imageerrors', title: 'Afbeelding fouten', component: () => import('@custom/pages/Product/ImageErrors') },
  { path: '/products/import', name:'products_import', title: 'Import', component: () => import('@custom/pages/Product/Import') },

  // MEMBERS
  { path: '/members', icon:'fa-people-group',sectionTitle:'Members', name:'members_list', title: 'Overzicht', component: () => import('@custom/pages/Member/List') },
  { path: '/members/pushnotifications', name:'members_pushnotifications', title: 'Push notifications', component: () => import('@custom/pages/Member/PushNotifications') },
  { path: '/members/notifications', name:'members_notifications', title: 'Meldingen', component: () => import('@custom/pages/Member/Notifications') },
  { path: '/members/tools', name:'members_tools', title: 'Tools', component: () => import('@custom/pages/Member/Tools') },
  
  // RECEPTEN
  { path: '/recipes', icon:'fa-pot-food',sectionTitle:'Recepten', name:'recepten_list', title: 'Overzicht', component: () => import('@custom/pages/Recipe/List') },
  { path: '/recipes/categories', name:'recepten_categories', title: 'Categorieën', component: () => import('@custom/pages/Recipe/Categories') },
  //{ path: '/recipes/new', name:'recipes_new', title: 'Nieuw recept', component: () => import('@custom/pages/Recipe/Edit') },
  { path: '/recipes/edit/:id', name:'recipes_edit', component: () => import('@custom/pages/Recipe/Edit'), meta:{title:'Recept details', controller:'recipes'} },
  { path: '/recipes/details/:id', name:'recipes_details', component: () => import('@custom/pages/Recipe/Details'), meta:{title:'Recept details', controller:'recipes'} },

  // STATISTICS
  { path: '/statistics', icon:'fa-chart-line-up',sectionTitle:'Statistiek', name:'statistics_products', title: 'Producten', component: () => import('@custom/pages/Statistic/Views'), meta:{type:'products'} },
  { path: '/statistics/shops', name:'statistics_shops', title: 'Supermarkten', component: () => import('@custom/pages/Statistic/Views'), meta:{type:'shops'} },
  { path: '/statistics/productcategories', name:'statistics_productcategories', title: 'Categorieën', component: () => import('@custom/pages/Statistic/Views'), meta:{type:'productcategories'} },
  { path: '/statistics/memberships', name:'statistics_memberships', title: 'Members', component: () => import('@custom/pages/Statistic/Views'), meta:{type:'members'} },
  { path: '/statistics/unsubscribes', name:'statistics_unsubscribes', title: 'Uitschrijvingen', component: () => import('@custom/pages/Statistic/Views'), meta:{type:'unsubscribes'} },
  { path: '/statistics/barcodes', name:'statistics_barcodes', title: 'Barcodes', component: () => import('@custom/pages/Statistic/Barcodes')},

  
  
  // SHOPS
  { path: '/shops', icon:'fa-store',sectionTitle:'Winkels', name:'shops_list', title: 'Overzicht', component: () => import('@custom/pages/Shop/List') },
  
  // CATEGORIES
  { path: '/productcategories', icon:'fa-list-tree',sectionTitle:'Categorie', className:'hasFileTree', name:'productcategories_overview', title: 'Overzicht', component: () => import('@custom/pages/Productcategory/Overview') },

  // MEDEWERKERS
{ path: '/users', sectionTitle:'Gebruikers', icon:'fa-person-chalkboard', title:'Overzicht',name: 'users_overview', component: () => import('@custom/pages/User/List') },
// { path: '/users/edit/:id', name: 'user_edit', component: () => import('@base/pages/User/Edit') },
// { path: '/users/new', name: 'user_add', component: () => import('@base/pages/User/Edit') },
{ path: '/users/details/:id', name: 'users_details', component: () => import('@base/pages/_Entity/Details'), meta:{title:'Gebruiker details', controller:'users'} },
{ path: '/users/edit/:id', name: 'users_edit', component: () => import('@base/pages/_Entity/Edit'), meta:{title:'Gebruiker bewerken', controller:'users', afterSave:{all:'/users'}} },
{ path: '/users/new',  name: 'users_add', component: () => import('@base/pages/_Entity/Edit'), meta:{title:'Gebruiker toevoegen', controller:'users', afterSave:{all:'/users'}} },

// roles
{ path: '/users/roles', sectionTitle:'Rollen', title:'Rollen', name: 'roles_overview', component: () => import('@base/pages/Role/List') },
{ path: '/roles/edit/:id', name: 'roles_edit', component: () => import('@base/pages/Role/Edit') },
{ path: '/roles/new', title:'Toevoegen', name: 'roles_add', component: () => import('@base/pages/Role/Edit') },

  
// SETTINGS
{ path: '/settings', sectionTitle: 'Instellingen', icon:'fa-gears', name:'settings', title:"Variabelen", component: () => import('@base/pages/Settings/Overview') },
{ path: '/settings/mailstatus', name:'settings_mailstatus', title:"Mail status", component: () => import('@base/pages/Settings/Mailstatus') },
{ path: '/settings/mailtemplates', name:'settings_mailtemplates', title:"Mail templates", component: () => import('@base/pages/Settings/Mailtemplates') },
{ path: '/settings/msgraph', name:'settings_msgraph', title:"Microsoft", component: () => import('@base/pages/Settings/MSGraph') },
{ path: '/settings/kittags', name:'settings_kittags', title:"Kit.com tags", component: () => import('@custom/pages/Tools/KitTags') },


 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  document.title = process.env.VUE_APP_COMPANY_NAME;
  next();
});

export default router
